import React from "react";
import { useProductsContext } from "./products.context";
import PaginationWithQueryState from "../../components/PaginationWithQueryState";

const ProductPagination = () => {
  const { totalPages } = useProductsContext();

  return <PaginationWithQueryState totalPages={totalPages} />;
};

export default ProductPagination;
